module.exports = __webpack_public_path__ + "img/p004.0491e795.png";